var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('timeline-card', {
    attrs: {
      "title": _vm.title
    }
  }, [_vm.repairEstimates.length > 0 ? _c('v-card', {
    key: 'timeline-repair-estimate' + _vm.repairEstimates[0].id,
    staticClass: "ma-2",
    attrs: {
      "flat": ""
    }
  }, [_c('refs-repair-estimate', {
    attrs: {
      "item": _vm.repairEstimates[0]
    },
    on: {
      "openDetail": function openDetail($event) {
        _vm.selectedRepairEstimate = $event;
      }
    }
  })], 1) : _vm._e(), _vm.showAll && _vm.repairEstimates.length > 1 ? _vm._l(_vm.repairEstimates.slice(1), function (repairEstimate) {
    return _c('v-card', {
      key: 'timeline-repair-estimate' + repairEstimate.id,
      staticClass: "ma-2",
      attrs: {
        "flat": ""
      }
    }, [_c('refs-repair-estimate', {
      attrs: {
        "item": repairEstimate
      },
      on: {
        "openDetail": function openDetail($event) {
          _vm.selectedRepairEstimate = $event;
        }
      }
    })], 1);
  }) : _vm._e(), _vm.repairEstimates.length > 1 ? _c('div', {
    staticClass: "d-flex justify-end"
  }, [_c('v-btn', {
    staticClass: "mr-2",
    attrs: {
      "x-small": "",
      "text": "",
      "elevation": 0
    },
    on: {
      "click": function click($event) {
        _vm.showAll = !_vm.showAll;
      }
    }
  }, [_vm._v(" " + _vm._s(_vm.showAll ? _vm.$t("showLess") : _vm.$t("showMore")) + " ")])], 1) : _vm._e(), _vm.selectedRepairEstimate ? _c('repair-estimate-side-card', {
    attrs: {
      "value": _vm.selectedRepairEstimate
    },
    on: {
      "close": function close($event) {
        _vm.selectedRepairEstimate = null;
      }
    }
  }) : _vm._e()], 2);
}
var staticRenderFns = []

export { render, staticRenderFns }